import React from "react";

function index() {
  return <div>Appointments</div>;
}

export default index;
